import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isStaff } from '@achievable-me/tundra-wizard/auth';
import routes from '@achievable-me/tundra-wizard/routes';

const renderMergedProps = (component, ...rest) => {
  const finalProps = Object.assign({}, ...rest);
  return React.createElement(component, finalProps);
};

class Unauthorized extends Component {
  render() {
    return <div>Sorry, you&apos;re not authorized to view this page!</div>;
  }
}

class PropsRoute extends Component {
  render() {
    const { component, ...rest } = this.props;
    return (
      <Route
        {...rest}
        render={(routeProps) => {
          return renderMergedProps(component, routeProps, rest);
        }}
      />
    );
  }
}

class AuthenticatedRoute extends Component {
  render() {
    const { currentUser, location } = this.props;
    const { pathname } = location;

    const state = pathname === routes.auth.signOut ? {} : { from: location };

    if (!currentUser) {
      return (
        <Redirect
          to={{
            pathname: routes.auth.signIn,
            state,
          }}
        />
      );
    }

    return <PropsRoute {...this.props} />;
  }
}

class StaffRoute extends Component {
  render() {
    const { currentUser } = this.props;
    if (!currentUser) {
      return (
        <Redirect
          to={{
            pathname: routes.auth.signIn,
            state: { from: this.props.location },
          }}
        />
      );
    }

    if (!isStaff(currentUser)) {
      return <Unauthorized />;
    }

    return <PropsRoute {...this.props} />;
  }
}

class UnauthenticatedRoute extends Component {
  render() {
    const { currentUser } = this.props;

    if (currentUser) {
      return <Redirect to={{ pathname: '/' }} />;
    }

    return <PropsRoute {...this.props} />;
  }
}

export { AuthenticatedRoute, UnauthenticatedRoute, PropsRoute, StaffRoute };
